import React from 'react';
import { Skeleton } from '@mui/material';

import './mobile-product-list-skeleton-style.scss';

import MobileHorizontalProductThumbnailSkeleton from '@src/componentsNew/Skeleton/mobile/components/MobileHorizontalProductThumbnailSkeleton';
import MobileVerticalProductThumbnailSkeleton from '@src/componentsNew/Skeleton/mobile/components/MobileVerticalProductThumbnailSkeleton';

import { SKELETON_COLOR } from "@src/utils/constants";

interface IProps {
  type: 'vertical' | 'horizontal' | 'image';
  hasTitle?: boolean;
  hasTitleRightArea?: boolean;
  hasBottomDivider?: boolean;
}

const MobileProductListSkeleton = ({ type, hasTitle, hasTitleRightArea, hasBottomDivider }: IProps) => {
  return (
    <div className="mobile-product-list-skeleton-wrapper">
      {
        hasTitle &&
        <div className='title-area'>
          <Skeleton variant="rectangular" width={100} height={30} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }} />

          {
            hasTitleRightArea &&
            <Skeleton variant="rectangular" width={52} height={30} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }} />
          }
        </div>
      }

      <div className={`mobile-product-list-skeleton ${type}`}>
        {
          type === 'vertical' &&
          Array.from({ length: 6 }).map((_, index) => (
            <MobileHorizontalProductThumbnailSkeleton key={index} />
          ))
        }
        {
          type === 'horizontal' &&
          Array.from({ length: 6 }).map((_, index) => (
            <MobileVerticalProductThumbnailSkeleton key={index} />
          ))
        }
        {
          type === 'image' &&
          Array.from({ length: 6 }).map((_, index) => (
            <Skeleton key={index} variant="rectangular" width="100%" style={{ backgroundColor: SKELETON_COLOR, height: "unset", aspectRatio: "308/189", borderRadius: 6 }} />
          ))
        }
      </div>

      {
        hasBottomDivider &&
        <Skeleton variant="rectangular" width="100%" height={4} style={{ backgroundColor: SKELETON_COLOR, marginTop: 16 }} />
      }
    </div>
  );
};

export default MobileProductListSkeleton;
